//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//

import axios from 'axios';
import wxlogin from 'vue-wxlogin';
import QRCode from 'qrcode';
export default {
 data () {
 return {
	options: [{id:0,name:'考研词霸'}, {id:6,name:'学术资源'}, {id:5,name:'书库'},{'id':9,name:'考研AI'}],
	showDropdown: false,
   code1:'',
   mo:false,
   mo1:false,
   mo2:false,
   way:1,
   list:[],
   list1:[],
   type:1,
   phone:'',
   password:'',
   phoneflag:false,
   wxfalg:true,
   bangding:false,
   forpwdflag:false,
   interest:false,
   interest1:false,
   infoflag:false,
   hotflag:false,
   notdl:1,
   rcode:'',
   rphone:'',
   rpassword:'',
   fphone:'',
   fcode:'',
   fpassword:'',
   frpassword:'',
   kehuflag:false,
   kehu:'',
   info:{},
   erweima:'',
   xcximg:'',
   xcx:'',
   logoinfo:{},
   icons:'',
   content:'',
   system:'',
    shouyi:'',
    share:'',
    msgcount:0,
    count:0,
    wxdata:{},
    wxdataflag:false,
    href:'',
    qrCodeflag:false,
	selectedValue: 1,
	carsi:'',
 }
 },
 components:{
   'v-header': "header"
 },
 mounted(){
     this.$axios.post( `/v9/index/getPcGetInfo`).then(res => {
      if(res.data.code == 200){
        this.icons=res.data.data.PC_logo_introduction
      }
    })
     this.$axios.post( `/v1/index/getDown`).then(res => {
      if(res.data.code == 200){
          QRCode.toCanvas(document.getElementById('canvasapp'),res.data.data, function (error) {
            if (error) console.error(error)
          })
        // this.icons=res.data.data.PC_logo_introduction
      }
    })
    if(localStorage.getItem("TOKEN")){
        this.$axios.post(`/v8/pc_message/getMessage`,{type:1}).then(res=>{
            if(res.data.code==200){
              this.system=res.data.unread_number
            }
          })
           this.$axios.post(`/v8/pc_message/getMessage`,{type:3}).then(res=>{
          if(res.data.code==200){
            this.shouyi=res.data.unread_number
          }
        })
        this.$axios.post(`/v8/pc_message/getMessage`,{type:4}).then(res=>{
          if(res.data.code==200){
            this.share=res.data.unread_number
          }
        })
        //最新购买
        axios.post(`/v1/video/videoList`,{page:1}).then(res => {
            this.list = res.data.data;
          });
        //最近学习
        axios.post(`/v1/video/playLogList`).then(res => {
            this.list1 = res.data.data;
          });
    }
    //  系统
    //获取微信登录的code
  var code = this.parseQueryString(window.location.href).code,state = this.parseQueryString(window.location.href).state;
  
  if(!localStorage.getItem("TOKEN") && code){
     this.$axios.post('/member/login',{code:code,terminal:5}).then(res=>{
        if(res.data.code==1){
           this.$tips('关联成功',3000);
		   // this.$tips(res.data.msg)
           this.phoneflag=false
          localStorage.setItem("TOKEN",res.data.data.token);
          localStorage.setItem("member_id",res.data.data.member_id);
           this.notdl=2
            localStorage.removeItem('phoneflag')
            this.$axios.post( `/v8/PC_Member/pc_member_info`).then(res => {
              if(res.data.code == 200){
                this.info=res.data.data
                //最新购买
                axios.post(`/v1/video/videoList`,{page:1}).then(res => {
                    this.list = res.data.data;
                  });
                  //最近学习
                axios.post(`/v1/video/playLogList`).then(res => {
                    this.list1 = res.data.data;
                  });
                  //  系统
                this.$axios.post(`/v1/message/getMessage`,{type:1}).then(res=>{
                  if(res.data.code==200){
                    this.system=res.data.unread_number
                  }
                })
              }
			  if(res.data.code == 500){
				  this.$tips(res.data.msg);
				  this.notdl=3
				  localStorage.removeItem('TOKEN')
			  }
            })
        }
      })
  }
 },
 created () {
   this.phoneflag=JSON.parse(localStorage.getItem('phoneflag'))
   if(this.phoneflag==true){
     this.uesrname(1)
   }
	
   if(localStorage.getItem('TOKEN')){
		this.$axios.post( `/v8/PC_Member/pc_member_info`).then(res => {
		  if(res.data.code == 200){
			this.notdl=2
			this.info=res.data.data
		  }else{
			  localStorage.removeItem('TOKEN');
			  this.notdl=1
		  }
		  
		})
   }
   this.$axios.post(`/v8/PC_Member/pc_ip_info`).then(res =>{
	   if(res.data.code == 300){
		   this.carsi = true
		   this.info=res.data.data
		   this.notdl= 0
	   }
   		if(res.data.code == 200){
   		  this.notdl=3
   		  this.info=res.data.data
		  localStorage.setItem('IP',res.data.data.ip_id);
		  localStorage.setItem('content',res.data.data.ip_content);
   		}else{
			localStorage.removeItem('IP');
		} 
   })
   
    this.$axios.post( `/v8/PC_index/number_two`).then(res => {
        if(res.data.code == 200){
          this.erweima=res.data.data.public_img_url
		  this.xcximg=res.data.data.xcx_img_url
        }
      })
   this.$axios.post( `/v1/index/logo`).then(res => {
      if(res.data.code == 1){
        this.logoinfo=res.data.data
      }
    })
    this.content=localStorage.getItem('search')
	this.selectedValue=localStorage.getItem('select')? localStorage.getItem('select'):1;
 },
 methods: {
	selectOption(id, event) {
		if(id == 9){
			window.location.href = 'https://gpt.51yantu.cn/';
		}
		this.$axios.get('/page/wanxue?wid='+id).then(res =>{
			window.location.href = res.data.data;
		})
	    this.selectedOption = option;
	    this.showDropdown = false;
	    // event.stopPropagation();
	    // event.preventDefault();
	  },
	hideDropdown() {
		this.showDropdown = false;
	},
	carsi1(){
		if(this.carsi){
			this.$tips('已登录')
		}else{
			window.location.href = 'https://sp-kyyls.carsi.edu.cn/api/authorize?response_type=code&client_id=kyyls&state=kyyls';
		}
	},
    next(){
     if(this.mo1){
        // this.$axios.post( `v1/member/verificationPhone`,{code:this.code1}).then(res => {
        //   if(res.data.code == 200){
        //     this.type=3
        //   }else{
        //     this.$tips(res.data.msg)
        //   }
        // })
     }
     else{
       this.$tips('请选择是否同意协议')
     }
   },
   appdown(){
     this.qrCodeflag=!this.qrCodeflag
   },
   changeway(a){
     this.way=a
   },
   changetype(a){
     this.type=a
   },
   changemo(){
     this.mo=!this.mo
   },
   changemo1(){
     this.mo1=!this.mo1
   },
   changemo2(){
     this.mo2=!this.mo2
   },
    parseQueryString(url) {
        var obj = {};
        var keyvalue = [];
        var key = "",
          value = "";
        var paraString = url
          .substring(url.indexOf("?") + 1, url.length)
          .split("&");
        for (var i in paraString) {
          keyvalue = paraString[i].split("=");
          key = keyvalue[0];
          value = keyvalue[1];
          obj[key] = value;
        }
        return obj;
      },
   apply(){
      this.$axios.post(`/v1/member/vip`).then(res=>{
        if(res.data.code==200){
            if(res.data.data.member_info.is_teacher==0){
                this.$tips('您还不是导师~');
            }else{
              this.$router.push("/teacher");
            }
          }
    })
   },
   toPage(router){
     this.$router.push(router)
   },
   uesrname(sign){
      this.type=sign
      this.phoneflag=true
      this.$axios.post(`/v1/Pcwxlogin/index`).then(res=>{
        this.wxdata=res.data.data
         this.wxdataflag=true
     })
   },
   error(){
      this.phoneflag=false
      this.wxfalg=true
      this.bangding=false
      this.forpwdflag=false
      this.kehuflag=false
      localStorage.removeItem('phoneflag')
   },
   //注册发送验证码
   getCode(){
      this.$axios.get(`/v1/sms`, {params: {phone:this.rphone,sendType: 'register'}}).then( res => {
            if(res.data.code==200){
              this.$tips(res.data.msg)
            }else{
              this.$tips(res.data.msg)
            }
        })
   },
   //忘记密码发送验证码
   forpwdcode(){
      this.$axios.get(`/v1/sms`, {params: {phone: this.fphone,sendType: 'forgetPwd'}}).then( res => {
          if(res.data.code==200){
              this.$tips(res.data.msg)
            }else{
              this.$tips(res.data.msg)
            }
        })
   },
   wxdl(){
     this.wxfalg=false
   },
   forget(){
     this.forpwdflag=true
   },
   follows(){
     this.interest=!this.interest
   },
   follows1(){
     this.interest1=!this.interest1
   },
   infotitle(){
     this.infoflag=!this.infoflag
   },
   searching(){
     this.hotflag=!this.hotflag
   },
   nofocus(){
     this.hotflag=!this.hotflag
   },
   searching1(){
     localStorage.setItem('search',this.content)
	 localStorage.setItem('select',this.selectedValue)
	 if(this.selectedValue == 1){
		this.$router.replace('/classify?way=1&content='+this.content) 
	 }else{
		this.$router.replace('/material?way=1&content='+this.content) 
	 }
     
     let NewPage = '_empty' + '?time=' + new Date().getTime()/500;
    this.$router.push(NewPage);
    this.$router.go(-1);
   },
   gotoup(){
	   this.$axios.post( `/v8/PC_Member/outCarsi`).then(res => {
	       
		})
		this.$axios.post( `https://sp-kyyls.carsi.edu.cn/Shibboleth.sso/Logout`).then(res => {
		    
		})
     this.infoflag=false
     this.$tips("退出登录成功")
     localStorage.removeItem("TOKEN");
     this.notdl=1
	 this.carsi = false
     this.$router.push('index')
	 
   },
   //登录
   denglu(){
        this.$axios.post( `/v1/login/member_login`,
        {phone:this.phone,
        password:this.password
        }).then(res => {
            if(res.data.code==200){
              this.$tips(res.data.msg)
               localStorage.setItem("TOKEN",res.data.data.info.token);
               localStorage.setItem("member_id",res.data.data.info.member_id);
               this.phoneflag=false
               this.notdl=2
               localStorage.removeItem('phoneflag')
              this.$axios.post( `/v8/PC_Member/pc_member_info`).then(res => {
                if(res.data.code == 200){
                  this.info=res.data.data

                }
              })
            }
            if(res.data.code!='200'){
               this.$tips(res.data.msg)
            }
        })
   },
   //注册
   newnickname(){
     this.$axios.post(`/v1/registered`, {
          phone: this.rphone,
          password: this.rpassword,
          code: this.rcode
        }).then( res => {
          if(res.data.code == 200){
            this.$tips(res.data.msg)
            this.type=1
          }else{
            this.$tips(res.data.msg)
          }
        })
   },
   forgetpwd(){
     this.type=4
   },
   //忘记密码
   fdenglu(){
        this.$axios.post(`/v1/login/resetPwd`, {
          phone: this.fphone,
          password: this.fpassword,
          repassword: this.frpassword,
          code:this.fcode
        }).then( res => {
          if(res.data.code == 200){
            this.$tips(res.data.msg)
            this.phoneflag=false
          }else{
            this.$tips(res.data.msg)
          }
        })
   },
   //客户协议
  //  kehuget(){
  //     this.$axios.post( `/v8/PC_index/login_do`,{type:1}).then(res => {
  //         if(res.data.code == 200){
  //            this.kehuflag=true
  //            this.kehu=res.data.data
  //         }else{
  //           this.$tips(res.data.msg)
  //         }
  //       })
  //  },
   //风险协议
  //  fengxian(){
  //    this.$axios.post( `/v8/PC_index/login_do`,{type:2}).then(res => {
  //         if(res.data.code == 200){
  //            this.kehuflag=true
  //            this.kehu=res.data.data
  //         }else{
  //           this.$tips(res.data.msg)
  //         }
  //       })
  //  },
   //法律声明
  //  law(){
  //     this.$axios.post( `/v8/PC_index/login_do`,{type:3}).then(res => {
  //         if(res.data.code == 200){
  //            this.kehuflag=true
  //            this.kehu=res.data.data
  //         }else{
  //           this.$tips(res.data.msg)
  //         }
  //       })
  //  }
 },
 components:{
   wxlogin
 },
 props:{
    nowHref: {
      type: String,
      default: ""
    },
  }
}



// WEBPACK FOOTER //
// ./src/components/common/header.vue